// extracted by mini-css-extract-plugin
export var button = "Button-module--button--Ui3Hp";
export var primary = "Button-module--primary--23j5n Button-module--button--Ui3Hp";
export var secondary = "Button-module--secondary--37hJq Button-module--button--Ui3Hp";
export var outline = "Button-module--outline--10GKo Button-module--button--Ui3Hp";
export var text = "Button-module--text--1Cjq5 Button-module--button--Ui3Hp";
export var white = "Button-module--white--3QaHB Button-module--button--Ui3Hp";
export var light = "Button-module--light--3KmB1 Button-module--button--Ui3Hp";
export var icon = "Button-module--icon--3CJtP";
export var left = "Button-module--left--2TFV7";
export var right = "Button-module--right--2-x_f";